export default "__VITE_ASSET__BSqX53NS__"